
import { server } from "/lib/publicEnv";
import Thumbnail from "/componentry/Clients/Thumbnail.jsx";
import LoadingThumbnail from "/componentry/Clients/LoadingThumbnail.jsx";
import { PagewideContext } from "/componentry/Root/Shared/PagewideContext.jsx";
import { fetchClients } from "/lib/helpers";
import { useEffect, useState, useContext } from "react";
import { useRouter } from "next/router";

export default function Clients(props) {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const router = useRouter();
    const { pageContext, setPageContext } = useContext(PagewideContext);
    
    useEffect(() => {
        async function getClients() {
            if (!loading) return;
            const clients = await fetchClients({ context: { state: pageContext, setState: setPageContext, loading }, bigClients: false });
            let sortedClients = clients.sort((a, b) => b.channelSocial?.subscribers - a.channelSocial?.subscribers);
            //sortedClients = [sortedClients.find(c => c.id === "UCxlyTwuE1uuieLnl_tjBYVQ"), ...sortedClients.filter(c => c.id !== "UCxlyTwuE1uuieLnl_tjBYVQ")]; 
            setClients(sortedClients);
            setLoading(false);
        };

        getClients();
    }, [router.isReady]);

    return (
        <>
            <div className="flex flex-col gap-y-8 px-12 py-4 pt-8 md:py-12">
                <h1 className="text-2xl">All Clients</h1>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-8 md:gap-x-12 lg:gap-x-16 xl:gap-x-20 2xl:gap-x-24 gap-y-4 items-center">
                    {
                        ((clients.length > 0 && !loading) && (
                            <>
                                {
                                    clients.map((client, index) => {
                                        if (!client.channelSocial?.subscribers) return;
                                        return (
                                            <Thumbnail key={index} id={client.id} me={client.id == "UCxlyTwuE1uuieLnl_tjBYVQ"} href={`https://youtube.com/channel/${client.id}`} name={client.name} thumb={client.thumbnail.high.url} subscribers={client.channelSocial.subscribers} />
                                        )
                                    }).filter(client => client !== null)
                                }
                            </>
                        ))
                    }
                    {
                        (() => {
                            if (loading) {
                                const k = [...Array(40).keys()];
                                return (
                                    <>
                                        {
                                            (k).map((i) => (
                                                <LoadingThumbnail key={i} />
                                            ))
                                        }
                                    </>
                                );
                            }
                        })()
                    }
                </div>
            </div>
        </>
    );
};

